<div id="modal-content-wrapper">
  <div class="card card-secondary card-outline">
    <div class="card-header bg-light">
      <h4 class="card-title mb-0">Adicionar Unidades Gestoras</h4>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancelar()"><i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <mat-toolbar class="table-header">
        <mat-toolbar-row class="px-1">
          <div class="input-group input-group-sm" style="width: 100%;">
            <input type="text" name="table_search" class="form-control float-right" placeholder="Filtrar por..."
              (keyup)="filtrar($event)" />
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort matSortDisableClear matSort matSortActive="sigla"
          matSortDirection="asc" [hidden]="semDados">

          <ng-container matColumnDef="selecao">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox  *ngIf="!modoSelecaoUnica" (click)="$event.stopPropagation()" color="primary" (change)="selecionarTodos()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                color="primary"
                [checked]="element.selecionado"
                (change)="onItemSelecionado($event.checked, element)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element?.id">{{element?.id}} </span>
              <span *ngIf="element?.value">{{element?.value}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ug">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> UG </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element?.sigla">{{element?.sigla}} - {{element?.nome}}</span>
              <span *ngIf="element?.text">{{element?.text}}</span>
             </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
              (click)="!modoSelecaoUnica && (element.selecionado = !element.selecionado)"
              class="clickable"
              [ngClass]="{'bg-light': element.selecionado}">
          </tr>

        </table>
        <h5 [hidden]="!semDados" class="table-no-data">Sem dados a exibir</h5>
      </div>
      <mat-paginator [hidden]="semDados" [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-primary btn-sm mr-1" (click)="concluir()">
        <i class="fas fa-check"></i> Adicionar
      </button>

      <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
        <i class="fas fa-times"></i> Cancelar
      </button>
    </div>
  </div>
</div>
